import * as React from "react";
import * as ResizablePrimitive from "react-resizable-panels";

import { cn } from "../../lib/utils";

function ResizablePanelGroup({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.Group>) {
  return (
    <ResizablePrimitive.Group
      className={cn("flex h-full w-full", className)}
      {...props}
    />
  );
}

const ResizablePanel = ResizablePrimitive.Panel;

/**
 * A bare divider: invisible until the pointer is over it, then a thin line.
 *
 * The separator is only a few pixels wide, but the library widens the pointer
 * hit region around it (10px with a mouse, 20px with touch) and reports the
 * result on `data-separator` — so styling off that attribute rather than CSS
 * `:hover` lights the line up from anywhere in the grabbable gutter.
 *
 * `aria-orientation` is the separator's own axis, which is the opposite of the
 * group's: a horizontal group (side-by-side panels) gets vertical dividers.
 */
function ResizableHandle({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.Separator>) {
  return (
    <ResizablePrimitive.Separator
      className={cn(
        "relative shrink-0 bg-transparent transition-colors focus-visible:outline-none",
        "aria-[orientation=vertical]:w-1 aria-[orientation=horizontal]:h-1",
        "data-[separator=hover]:bg-sky-500/60 data-[separator=focus]:bg-sky-500/60",
        "data-[separator=active]:bg-sky-500",
        className,
      )}
      {...props}
    />
  );
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
